import React, { useContext } from 'react';
import { Badge } from 'features/catalog/useBadges';

const BattleOpenBadgeContext = React.createContext<((badge: Badge) => void) | null>(null);

export const BattleOpenBadgeProvider: React.FC<{
  onOpenBadge?: (badge: Badge) => void;
  children: React.ReactNode;
}> = ({ onOpenBadge = null, children }) => (
  <BattleOpenBadgeContext.Provider value={onOpenBadge}>{children}</BattleOpenBadgeContext.Provider>
);

export const useBattleOpenBadge = (): ((badge: Badge) => void) | null => useContext(BattleOpenBadgeContext);
